import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "left-border-trigger" }
const _hoisted_2 = { class: "inline-flex project-name-and-remove" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "project-row__remove q-ml-xs" }
const _hoisted_5 = { class: "q-ml-sm" }
const _hoisted_6 = { class: "project-row" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "box-container",
    style: _normalizeStyle(`border-left-color: ${_ctx.el.Stage?.Color};`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.el.Stage?.Name)
        ? (_openBlock(), _createBlock(_component_app_tooltip, {
            key: 0,
            text: _ctx.el.Stage.Name
          }, {
            activator: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "left-border-trigger__hit" }, null, -1)
            ])),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "q-mr-xs project-row__link",
        href: _ctx.projectURI,
        target: "_blank"
      }, _toDisplayString(_ctx.el.Name), 9, _hoisted_3),
      (!_ctx.hideRemoveBtn)
        ? (_openBlock(), _createBlock(_component_app_tooltip, {
            key: 0,
            text: _ctx.$t('remove'),
            style: { height: '16px' }
          }, {
            activator: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_app_icon, {
                  name: "close",
                  width: "16px",
                  color: "#979797",
                  "hover-color": "#616161",
                  cursor: "pointer"
                }),
                _createVNode(_component_q_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "row items-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_app_icon, {
                              name: "delete-outline",
                              width: "18px",
                              color: "#979797"
                            }),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("sure_delete")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                          onKeydown: _ctx.windowKeyDown,
                          align: "right"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_q_btn, {
                              size: "sm",
                              flat: "",
                              label: _ctx.$t('cancel'),
                              color: "dark",
                              ref: 'cancelbtn'
                            }, null, 8, ["label"]), [
                              [_directive_close_popup]
                            ]),
                            _withDirectives(_createVNode(_component_q_btn, {
                              size: "sm",
                              flat: "",
                              label: _ctx.$t('remove'),
                              autofocus: "",
                              color: "dark",
                              ref: 'okbtn',
                              onClick: _ctx.detach
                            }, null, 8, ["label", "onClick"]), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _: 1
                        }, 8, ["onKeydown"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        style: {"display":"flex","flex-direction":"column"},
        innerHTML: _ctx.displayHtml
      }, null, 8, _hoisted_7),
      (_ctx.el && _ctx.el.Clients?.length > 2)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = !_ctx.isExpanded)),
            class: "q-mt-xs entity-link",
            style: {"font-size":"12px"}
          }, _toDisplayString(_ctx.isExpanded ? _ctx.$t('ui_collapse') : _ctx.$t('more_count_label', { count: _ctx.el.Clients?.length - 2 })), 1))
        : _createCommentVNode("", true),
      (_ctx.el && _ctx.el.Tags && _ctx.el.Tags?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.el.Tags, (tag, ti) => {
              return (_openBlock(), _createElementBlock("span", {
                key: 'tag_finw_'+ti,
                class: "tag-class q-mr-xs"
              }, "#" + _toDisplayString(tag.Name + (ti === _ctx.el.Tags?.length - 1 ? '' : ',')), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}